import styled from 'styled-components'
import { BaseColor, Color, ColorShade, rem, themeColor, transitions } from '~theme'

// eslint-disable-next-line import/prefer-default-export -- To keep "Styled.xxx" convention
export const Input = styled.input`
  position: relative;
  flex-shrink: 0;
  display: inline-block;
  height: ${rem(20)};
  width: ${rem(20)};
  margin: 0;
  border-radius: 50%;
  background: ${themeColor(BaseColor.shade_0)};
  border: 1px solid ${themeColor(BaseColor.shade_50)};
  color: transparent;
  --ring-color: transparent;
  outline: 1px solid var(--ring-color);
  outline-offset: 0;
  ${transitions(['background-color', 'color', 'border-color', 'outline'])};
  cursor: pointer;
  appearance: none;

  &:hover {
    border-color: ${themeColor(BaseColor.shade_70)};
  }

  &:focus-visible {
    border-color: ${themeColor(Color.primary)};

    &:checked {
      border-color: ${themeColor(BaseColor.shade_0)};
      --ring-color: ${themeColor(Color.primary)};
      background-color: ${themeColor(Color.primary)};
    }
  }
  &:checked {
    background-color: ${themeColor(Color.primary)};
    border-color: ${themeColor(Color.primary)};
    color: ${themeColor(Color.primary, ColorShade.foreground)};
  }
  &:disabled {
    background-color: ${themeColor(BaseColor.shade_30)};
    border-color: ${themeColor(BaseColor.shade_30)};
    cursor: default;

    &:checked {
      background-color: ${themeColor(BaseColor.shade_40)};
      border-color: ${themeColor(BaseColor.shade_40)};
      color: ${themeColor(BaseColor.shade_20)};
    }
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 27.777777778%;
    left: 27.777777778%;
    right: 27.777777778%;
    bottom: 27.777777778%;
    border-radius: 50%;
    background-color: currentColor;
  }
`
